export * from './feature-item.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/feature/feature-item/index.ts